/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_accounts_colombia_create_drawer_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Se creará una cuenta en pesos colombianos (Bancolombia)`
};

const en_accounts_colombia_create_drawer_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `A COP account (Bancolombia) will be created`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const accounts_colombia_create_drawer_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.accounts_colombia_create_drawer_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("accounts_colombia_create_drawer_subtitle", locale)
	if (locale === "es") return es_accounts_colombia_create_drawer_subtitle(inputs)
	return en_accounts_colombia_create_drawer_subtitle(inputs)
};
export { accounts_colombia_create_drawer_subtitle as "accounts.colombia.create_drawer_subtitle" }